import React from 'react';
import { CheckCircle2 } from 'lucide-react';

export default function ApprovalCard({ step, highlights }) {
  return (
    <div style={{ 
      minHeight: '400px', 
      background: '#fff', 
      borderRadius: '10px', 
      padding: '32px', 
      border: '1px solid #e0e0e0', 
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
      position: 'relative' ,
       animation: "slideInRight 0.55s cubic-bezier(0.16, 1, 0.3, 1) both",
    }}>
    <style>{`
        @keyframes slideInRight {
          0%   { opacity: 0; transform: translateX(48px) scale(0.95) translateY(6px); filter: blur(3px); }
          60%  { opacity: 1; filter: blur(0px); }
          100% { opacity: 1; transform: translateX(0) scale(1) translateY(0); filter: blur(0px); }
        }
      `}</style>
      {/* Connection dot */}
      <div style={{
        position: 'absolute',
        left: '-6px',
        top: 'calc(50% - 20px)',
        transform: 'translateY(-50%)',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        backgroundColor: 'white',
        border: '4px solid #a0aab4',
        zIndex: 1
      }} />
      
      {/* Status Badge */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '32px' }}>
        <div style={{ 
          width: '16px', 
          height: '16px', 
          borderRadius: '50%', 
          background: '#10b981' 
        }}></div>
        <span style={{ 
          color: '#059669', 
          fontWeight: '600', 
          fontSize: '18px', 
          letterSpacing: '0.025em' 
        }}>
          APPROVED
        </span>
      </div>

      {/* Title */}
      <h1 style={{ 
        fontSize: '20px', 
        fontWeight: 'bold', 
        color: '#0f172a', 
        marginBottom: '12px',
        margin: '0 0 12px 0'
      }}>
        {step?.title || 'Portfolio Monitoring'}
      </h1>
      
      {/* Subtitle/Meta */}
      <p style={{ 
        color: '#475569', 
        fontSize: '14px', 
        marginBottom: '40px',
        margin: '0 0 40px 0'
      }}>
        Processed by {step?.processedBy || 'Amav Singh'} on {step?.date || 'Apr 24, 2024 at 1:00pm'}
      </p>

      {/* Key Highlights Section - Only show if highlights provided */}
      {highlights && (
        <div style={{ marginBottom: '24px' }}>
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: 'bold', 
            color: '#0f172a', 
            marginBottom: '24px',
            margin: '0 0 24px 0'
          }}>
            Key Highlights
          </h2>
          
          {/* Highlight Items */}
          {highlights.includes('|') ? (
            highlights.split('|').map((highlight, index) => (
              <div key={index} style={{ display: 'flex', gap: '5px', marginBottom: '5px' }}>
                <div style={{ flexShrink: 0 }}>
                  <CheckCircle2 size={24} style={{ color: 'green', strokeWidth: '1.5'}} />
                </div>
                <p style={{ 
                  color: '#475569', 
                  lineHeight: '1.6',
                  margin: 0
                }}>
                  {highlight.trim()}
                </p>
              </div>
            ))
          ) : (
            <div style={{ display: 'flex', gap: '16px' }}>
              <div style={{ flexShrink: 0 }}>
                <CheckCircle2 size={24} style={{ color: '#64748b', strokeWidth: '1.5' }} />
              </div>
              <p style={{ 
                color: '#475569', 
                lineHeight: '1.6',
                margin: 0
              }}>
                {highlights.replace(/\|/g, ', ')}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
